import React from 'react';
import { TransformCTA } from '../TransformCTA';
import { painPoints } from '../../data/content';
export function PainPoints() {
  return <section className="w-full bg-navy-50/60 px-4 py-14 sm:py-20" data-id="element-227" data-mp="1twgsyk0u7w5y">
      <div className="mx-auto w-full max-w-5xl" data-id="element-228" data-mp="27mka4wkv0zoj">
        <p className="text-center font-display text-xl font-bold leading-snug text-navy-950 sm:text-3xl" data-id="element-229" data-mp="27oevgc01mtt5">
          👉 Si alguna de estas situaciones te resulta familiar, esta Ruta fue
          creada para ti.
        </p>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-230" data-mp="2clnhinobbhzo">
          {painPoints.map(point => <li key={point.text} className="rounded-2xl border border-navy-100 bg-white p-5" data-id="element-231" data-mp="2qloi020o0nem">
              <span className="text-3xl" aria-hidden="true" data-id="element-232" data-mp="2mk2wxtdz92tc">
                {point.emoji}
              </span>
              <p className="mt-3 text-[14px] leading-relaxed text-navy-900/85 sm:text-base" data-id="element-233" data-mp="w7f7fskqb14x">
                {point.text}
              </p>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-3xl rounded-3xl border border-navy-100 bg-white p-6 text-center sm:p-8" data-id="element-234" data-mp="1n94ryf1gv36y">
          <p className="font-display text-lg font-bold leading-snug text-navy-950 sm:text-2xl" data-id="element-235" data-mp="1s76amyuzd0hw">
            La buena noticia es que ninguna de esas situaciones ocurre por falta
            de conocimiento.
          </p>
          <p className="mt-3 text-[15px] leading-relaxed text-navy-800/80 sm:text-lg" data-id="element-236" data-mp="21yix1ay0eygj">
            Ocurren porque las recomendaciones están dispersas entre múltiples
            guías, artículos y consensos.
          </p>
          <p className="mt-3 text-[15px] font-semibold leading-relaxed text-navy-900 sm:text-lg" data-id="element-237" data-mp="2fvz84zr93gem">
            Ruta Hipotiroidismo™ reúne todo ese proceso en un único sistema de
            decisión clínica diseñado para responder exactamente lo que
            necesitas durante la consulta.
          </p>
        </div>

        <TransformCTA headline="Pasa de improvisar en cada TSH alterada a resolverla con un método claro." data-id="element-238" data-mp="qilz4x871476" />
      </div>
    </section>;
}